import { AgentForRootModule } from '@agent/agent-for-root.module';
import { DoBootstrap, Inject, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { setUpLocationSync } from '@angular/router/upgrade';
import { UpgradeModule } from '@angular/upgrade/static';
import { CoreForRootModule } from '@commons/core/core-for-root.module';
import { EngagementForRootModule } from '@engagement/engagement-for-root.module';
import { HistoryForRootModule } from '@history/history-for-root.module';
import { HypervisionForRootModule } from '@hypervision/hypervision-for-root.module';
import { LoginForRootModule } from '@login/login-for-root.module';
import { PageNotFoundForRootModule } from '@pagenotfound/pagenotfound-for-root.module';
import { PortalForRootModule } from '@portal/portal-for-root.module';
import { ResponderForRootModule } from '@responder/responder-for-root.module';
import { TrackingForRootModule } from '@tracking/tracking-for-root.module';
import { WallboardForRootModule } from '@wallboard/wallboard-for-root.module';
import { combineLatest, take } from 'rxjs';
import { WallboardConfForRootModuleModule } from 'src/wallboard-conf/wallboard-conf-for-root.module';

import {
  AppConf,
  AppInjector,
  AppRouter,
  CommonInterfaceFeatureModule,
  DeviceFacade,
  LibPhoneConf,
  ToolsNotificationFeatureModule,
  WINDOW,
  WindowWrapper,
} from '@contact/upgrade';

import { AppRoutingModule, Path } from './app-routing.module';
import { AppComponent } from './app.component';
import { initModuleAjs } from './app.module.ajs';

@NgModule({
  imports: [
    UpgradeModule,
    BrowserModule,
    BrowserAnimationsModule,

    AppRoutingModule,

    CoreForRootModule.instance(),
    LoginForRootModule.instance(),
    PortalForRootModule.instance({ path: Path.portal }),
    PageNotFoundForRootModule.instance(),
    AgentForRootModule.instance({ path: Path.agent }),
    EngagementForRootModule.instance({ path: Path.engagement }),
    HistoryForRootModule.instance({ path: Path.history }),
    HypervisionForRootModule.instance({ path: Path.hypervision }),
    ResponderForRootModule.instance({ path: Path.responder }),
    TrackingForRootModule.instance({ path: Path.tracking }),
    WallboardForRootModule.instance({ path: Path.wallboard }),
    WallboardConfForRootModuleModule.instance({ path: Path.wallboardConf }),

    ToolsNotificationFeatureModule,
    CommonInterfaceFeatureModule,
  ],
  declarations: [AppComponent],
})
export class AppModule implements DoBootstrap {
  constructor(
    private readonly router: AppRouter,
    private readonly upgrade: UpgradeModule,
    private readonly appConf: AppConf,
    private readonly libPhoneConf: LibPhoneConf,
    private readonly deviceFacade: DeviceFacade,
    private readonly injector: Injector,
    @Inject(WINDOW) private readonly window: WindowWrapper
  ) {}

  ngDoBootstrap(): void {
    combineLatest({
      appConf: this.appConf,
      libPhoneConf: this.libPhoneConf,
      device: this.deviceFacade.device$,
      route: this.router.current$,
    })
      .pipe(take(1))
      .subscribe(params => {
        AppInjector.injector = this.injector;
        // instantiate ng1 module
        const ng1Module = initModuleAjs(params);
        // bootstrap ng1 module
        this.upgrade.bootstrap(document.documentElement, [ng1Module], { strictDi: true });
        // router ng1 compatibility
        setUpLocationSync(this.upgrade);
        // should navigate manually
        // because we have unactivated the initial navigation (see app-routing.module)
        // to let the ng1Module boostrapped before to navigate
        const url = window.location.hash.startsWith('#/front/')
          ? window.location.hash.replace('#/front/', '')
          : window.location.hash.replace('#/', '');
        this.router.navigateByUrl(url);
      });
  }
}
